import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DeleteAttendanceController from "../../../Controllers/Admin/Attendance/DeleteAttendanceController";
import FetchAttendanceController from "../../../Controllers/Admin/Attendance/FetchAttendanceController";
import { getAuth } from "firebase/auth";
import GetUser from "../../../Controllers/Users/GetUser";

export default function AttendanceViewModel() {
  const location = useLocation();

  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [AuthUser, setAuthUser] = useState();

  const [ClassID, setClassID] = useState("");
  const [CourseID, setCourseID] = useState("");
  const [DeletingDocId, setDeletingDocId] = useState("");
  const [SubjectAttendance, setSubjectAttendance] = useState();
  const [refresh, setRefresh] = useState(false);
  const [IsAttendanceTaken, setIsAttendanceTaken] = useState(false); //Check for daily attendance

  useEffect(() => {
    setCourseID(location.pathname.split("/").pop());
    setClassID(location.pathname.split("/").slice(-2, -1)[0]);
  }, [location.pathname]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (ClassID && CourseID) {
        let attendance = await FetchAttendanceController(ClassID, CourseID);
        setSubjectAttendance([...attendance]);
      }
    };
    fetchData();
  }, [CourseID, ClassID, refresh]);

  useEffect(() => {
    if (SubjectAttendance) {
      console.log("CheckIsTodayAttendanceTaken");
      CheckIsTodayAttendanceTaken();
    }
  }, [SubjectAttendance, SubjectAttendance]);

  // Compare current date with the all attendance date to check that attendance is taken or not
  const CheckIsTodayAttendanceTaken = () => {
    let check = 0;
    SubjectAttendance.map(({ AttendanceDate }) => {
      if (
        AttendanceDate.toDate().getDate() === new Date().getDate() &&
        AttendanceDate.toDate().getMonth() === new Date().getMonth() &&
        AttendanceDate.toDate().getFullYear() === new Date().getFullYear()
      ) {
        return (check = 1);
      }
    });

    if (check === 1) {
      setIsAttendanceTaken(true);
    } else {
      setIsAttendanceTaken(false);
    }
  };

  // Action Confirmation Start
  const handleOpenDeleteDialog = (id) => {
    setDeletingDocId(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      let resp = await DeleteAttendanceController(DeletingDocId);
      setDeleteDialog(false);
      if (resp) {
        setRefresh(!refresh);
      }
    }
  };
  // Action Confirmation End

  return {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    ClassID,
    CourseID,
    SubjectAttendance,
    IsAttendanceTaken,
    AuthUser
  };
}
